import { render, staticRenderFns } from "./app.vue?vue&type=template&id=c36d7830&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=c36d7830&lang=scss&scoped=true&"
import style1 from "./app.vue?vue&type=style&index=1&id=c36d7830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36d7830",
  null
  
)

export default component.exports